import { isNonEmptyString } from '@vfde-sails/utils';
import { TariffMinimumDownload } from '../enums/content';

/**
 * Checks given variable if it's a string and not empty
 * and if an array is provided also checks whether it includes the value
 */
export const isValidId = (value: unknown, array: string[]): value is string =>
    isNonEmptyString(value) && array.includes(value);

/**
 * Checks if the given value is a key in the TariffMinimumDownload enum
 */
export const isMinimumDownloadKey = (value: unknown): value is keyof typeof TariffMinimumDownload =>
    typeof value === 'string' &&
    Object.keys(TariffMinimumDownload).includes(value);

/**
 * Checks if value is not null or undefined
 */
export const isNotNullOrUndefined = <T>(value: T | null | undefined): value is T => value !== null && value !== undefined;
